module.exports = "/_next/static/images/The4StepGuide-63ed388f21260951fdd8b6f74cb4b133.png";